import type { TimelineRow } from '@tabel/shared/agent-events/timeline';
import { Ban, Check, Square } from 'lucide-react';
import { memo } from 'react';
import { say } from '../texts';
import { Spinner } from './parts';

type Row = Extract<TimelineRow, { kind: 'step' }>;

const TONE: Readonly<Record<Row['state'], string>> = {
  running: 'text-ink-2',
  done: 'text-ink-2',
  error: 'text-bad',
  denied: 'text-bad',
  stopped: 'text-ink-2',
};

/**
 * Строка шага агента (contracts/ui.md §2; FR-032): подпись с сервера — «Смотрю правило «Обед»…» → «Посмотрел правило
 * «Обед»» или текст ошибки. Значок — вращение, галочка, запрет или квадрат; смысл значка дублирует подпись. Подпись не
 * мерцает. Долгий расчёт сервера — «(расчёт N)».
 */
export const StepRow = memo(function StepRow({ row }: { row: Row }) {
  return (
    <div
      data-step
      data-state={row.state}
      className={`flex min-h-7 items-start gap-2 text-[13px] ${TONE[row.state]}`}
    >
      <span className="flex h-5 w-4 shrink-0 items-center justify-center">
        {row.state === 'running' && <Spinner />}
        {row.state === 'done' && <Check size={16} strokeWidth={1.75} className="text-ok" aria-hidden />}
        {(row.state === 'error' || row.state === 'denied') && (
          <Ban size={16} strokeWidth={1.75} aria-hidden />
        )}
        {row.state === 'stopped' && (
          <Square size={14} strokeWidth={1.75} className="text-ink-3" aria-hidden />
        )}
      </span>
      <span className="min-w-0 py-0.5 leading-[1.4] break-words">
        {row.label}
        {row.jobId && (
          <>
            {' '}
            <span className="tabular-nums">{say.calc(row.jobId)}</span>
          </>
        )}
        {row.detail && <span className="block text-[12px] text-ink-2">{row.detail}</span>}
      </span>
    </div>
  );
});
